
export const fakeImage =  "../assets/media/avatars/blank.png";
export const fakeProImage =  "../assets/media/dummy.jpg";
